// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Styles
const Container = styled.div`
  color: ${colors.coral};
  display: inline;
  margin: ${props => props.margin};

  & > svg {
    height: ${props => props.height};
    width: ${props => props.width};
  }
`;

// Component
const DiscoveryCreditCardSvg = ({ height, margin, width }) => (
  <Container height={height} margin={margin} width={width}>
    <svg
      width="42px"
      height="25px"
      viewBox="0 0 42 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <defs>
        <rect
          id="path-1"
          x="-1.76214598e-12"
          y="0"
          width="41.627907"
          height="25"
          rx="4"
        />
        <path
          d="M10.0387433,25 L37.6271176,25 C39.8366925,25 41.627907,23.2148343 41.627907,20.9969802 L41.627907,14.0408619 C41.627907,14.0408619 30.471434,21.6116653 10.0387433,25 Z"
          id="path-3"
        />
      </defs>
      <g
        id="Checkout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Checkout_USA" transform="translate(-163.000000, -523.000000)">
          <g id="Discover-dark" transform="translate(163.000000, 523.000000)">
            <g id="Rectangle">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1" />
              </mask>
              <rect
                stroke="#E6772F"
                x="0.5"
                y="0.5"
                width="40.627907"
                height="24"
                rx="4"
              />
              <mask id="mask-4" fill="white">
                <use xlinkHref="#path-3" />
              </mask>
              <use id="Mask" fill="#E6772F" xlinkHref="#path-3" />
            </g>
            <path
              d="M7.61315448,12.4258396 C7.30064817,12.6932956 6.90282391,12.8102491 6.26665733,12.8102491 L6.00268049,12.8102491 L6.00268049,9.6185821 L6.26665733,9.6185821 C6.90282391,9.6185821 7.28538487,9.72766368 7.61315448,10.0084269 C7.951491,10.2985614 8.15480601,10.7461333 8.15480601,11.209074 C8.15480601,11.6742638 7.951491,12.1377668 7.61315448,12.4258396 L7.61315448,12.4258396 Z M6.46371047,8.80103255 L5.01937164,8.80103255 L5.01937164,13.6281735 L6.45490472,13.6281735 C7.21885253,13.6281735 7.77028822,13.4540553 8.2536261,13.0698333 C8.82776106,12.6147644 9.16844577,11.9276629 9.16844577,11.2158213 C9.16844577,9.79082604 8.05696433,8.80103255 6.46371047,8.80103255 L6.46371047,8.80103255 Z"
              id="Fill-13"
              fill="#1A1919"
            />
            <polygon
              id="Fill-14"
              fill="#1A1919"
              points="9.6218441 8.80103255 10.6012393 8.80103255 10.6012393 13.6281735 9.6218441 13.6281735"
            />
            <path
              d="M13.0063834,10.6511086 C12.415224,10.4434412 12.2424356,10.3051213 12.2424356,10.0442252 C12.2424356,9.74097088 12.5512239,9.51099993 12.9758568,9.51099993 C13.2701645,9.51099993 13.5126162,9.62383001 13.7709182,9.89953276 L14.2822388,9.25703852 C13.8597585,8.90093028 13.3541127,8.72062705 12.8028727,8.72062705 C11.910948,8.72062705 11.231144,9.31495297 11.231144,10.1008276 C11.231144,10.768062 11.5471726,11.1065523 12.4694283,11.4279868 C12.8549245,11.5563732 13.0508035,11.6440883 13.150015,11.7035022 C13.346481,11.8251412 13.4443227,11.9994468 13.4443227,12.2009291 C13.4443227,12.5935853 13.1194884,12.8822204 12.6803749,12.8822204 C12.2128874,12.8822204 11.8346315,12.6580597 11.6082258,12.2371022 L10.9746031,12.8248683 C11.4276101,13.4606152 11.9706314,13.7447521 12.7187289,13.7447521 C13.7390219,13.7447521 14.4579625,13.09045 14.4579625,12.158571 C14.4579625,11.3906892 14.1245181,11.0426402 13.0063834,10.6511086"
              id="Fill-15"
              fill="#1A1919"
            />
            <path
              d="M14.7667508,11.2158213 C14.7667508,12.6353812 15.9300884,13.7353808 17.4276531,13.7353808 C17.8499377,13.7353808 18.2119519,13.6555376 18.6577186,13.4540553 L18.6577186,12.3446844 C18.263808,12.723846 17.9180355,12.8734114 17.4707034,12.8734114 C16.4811327,12.8734114 15.7801949,12.1876219 15.7801949,11.209074 C15.7801949,10.2845045 16.503832,9.55204609 17.4276531,9.55204609 C17.8937708,9.55204609 18.2499145,9.71023312 18.6577186,10.0950174 L18.6577186,8.98695854 C18.2270196,8.77835407 17.8736154,8.69195097 17.4478084,8.69195097 C15.9588538,8.69195097 14.7667508,9.81350451 14.7667508,11.2158213"
              id="Fill-16"
              fill="#1A1919"
            />
            <polyline
              id="Fill-17"
              fill="#1A1919"
              points="26.6204656 12.041805 25.2765124 8.80103255 24.2049503 8.80103255 26.3414212 13.75 26.8683964 13.75 29.0463522 8.80103255 27.9832045 8.80103255 26.6204656 12.041805"
            />
            <polyline
              id="Fill-18"
              fill="#1A1919"
              points="29.4923145 13.6281735 32.2794325 13.6281735 32.2794325 12.8102491 30.4756234 12.8102491 30.4756234 11.5072678 32.2109433 11.5072678 32.2109433 10.6895308 30.4756234 10.6895308 30.4756234 9.6185821 32.2794325 9.6185821 32.2794325 8.80103255 29.4923145 8.80103255 29.4923145 13.6281735"
            />
            <path
              d="M34.1990862,11.0207115 L33.9137799,11.0207115 L33.9137799,9.56066766 L34.2151322,9.56066766 C34.8291866,9.56066766 35.1581303,9.8075069 35.1581303,10.2777572 C35.1581303,10.7609399 34.8291866,11.0207115 34.1990862,11.0207115 L34.1990862,11.0207115 Z M36.1702046,10.2252781 C36.1702046,9.32132543 35.5228841,8.80103255 34.3881163,8.80103255 L32.9283185,8.80103255 L32.9283185,13.6281735 L33.9137799,13.6281735 L33.9137799,11.6873836 L34.0415611,11.6873836 L35.3994079,13.6281735 L36.6085353,13.6281735 L35.0229131,11.5936709 C35.763966,11.4486036 36.1702046,10.9639216 36.1702046,10.2252781 L36.1702046,10.2252781 Z"
              id="Fill-19"
              fill="#1A1919"
            />
            <path
              d="M24.3434941,11.2270668 C24.3434941,12.6168261 23.1678285,13.7432527 21.7162494,13.7432527 C20.2650617,13.7432527 19.0892004,12.6168261 19.0892004,11.2270668 C19.0892004,9.83712011 20.2650617,8.71050608 21.7162494,8.71050608 C23.1678285,8.71050608 24.3434941,9.83712011 24.3434941,11.2270668"
              id="Fill-20"
              fill="#E6772F"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
);

DiscoveryCreditCardSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default DiscoveryCreditCardSvg;
